import React from "react";

function WhatisP2P() {
  return (
    <>
      <div className="container pb-70">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is a P2P Crypto Exchange?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A P2P (peer-to-peer) crypto exchange is a decentralized
                  platform that allows users to trade cryptocurrencies without
                  the involvement of any intermediaries or third parties.
                  Instead of relying on a centralized exchange to facilitate
                  transactions, buyers and sellers interact directly in
                  secondary market selling. The platform typically acts as an
                  escrow service to ensure the safe exchange of assets. Users
                  can post buy or sell offers, set their own prices, and
                  negotiate terms.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatisP2P;
